module.exports = __webpack_public_path__ + "static/media/banana.6823d456.gif";